export enum EmailStatusType {
  SEND = 'send',
  NOT_FOUND = 'notFound',
  ALREADY_SEND = 'alreadySend',
  TAKEN = 'taken',
  NOT_VERIFIED = 'notVerified',
  NOT_ALLOWED = 'notAllowed',
  CHANGE_SUCCESS = 'changeSuccess',
}

export enum ErrorStatusType {
  DEFAULT = 'default',
  GOOGLE_LOGIN = 'googleLogin',
  LOGIN = 'login',
  APPLE_LOGIN = 'appleLogin',
  SERVER_ERROR = 'serverError',
}

export enum SuccessStatusType {
  DEFAULT = 'default',
  CHANGED_DATA = 'changedData',
  SUBSCRIPTION_CANCEL = 'subscriptionCancel',
  SUBSCRIPTION_DOWNGRADE = 'subscriptionDowngrade',
  EMAIL_VERIFICATION = 'emailVerified',
}

export enum PasswordStatusType {
  WRONG = 'wrong',
  NO_RESET_TOKEN = 'noResetToken',
  CHANGED = 'changed',
}

export enum VoucherStatusType {
  PREVIOUSLY_PAID_SUB = 'previouslyPaid',
}

export enum UserUpdateStatusType {
  SCHOOL_NAME_AS_VOUCHER = 'schoolNameAsVoucher',
}

export enum MiscStatusType {
  TRANSLATOR_ACTIVE = 'translatorActive',
}

export enum ReferralStatusType {
  REDEEM_SUCCESS = 'redeemSuccess',
  WRONG_CODE = 'wrongCode',
  EXPIRED_CODE = 'expiredCode',
  INVITE_SUCCESS = 'inviteSuccess',
  INVITATION_EXPIRED = 'invitationExpired',
  REDEEM_SUCCESS_WELCOME = 'redeemSuccessWelcome',
  INVITE_ERROR = 'inviteError',
}

export enum ManagementStatusType {
  SELECT_SCHOOL = 'selectSchool',
  NO_VOUCHER_FOUND = 'selectSchoolWithVoucher',
  SCHOOL_NO_VOUCHER = 'schoolNoVoucher',
  SELECT_VOUCHER = 'selectVoucher',
  INVITE_ERROR = 'inviteError',
  INVITE_SUCCESS = 'inviteSuccess',
  INVITE_ERROR_PLURAL = 'inviteErrorPlural',
  INVITE_SUCCESS_PLURAL = 'inviteSuccessPlural',
  ROLE_CHANGE_SUCCESS = 'roleChangeSuccess',
  ROLE_CHANGE_ERROR = 'roleChangeError',
}

export enum WorksheetStatusType {
  CLASS_ADDED = 'classAdded',
  CLASS_REMOVED = 'classRemoved',
  CLASS_ADD_ERROR = 'classAddError',
  CLASS_REMOVE_ERROR = 'classRemoveError',
}
